import { css } from "styled-components";

export const CheckboxStyles = css(({ theme }) => ({
    ".Checkbox": {
        "&&&": {
            color: theme.palette.overlays[800][8],
        },
        "&&&.Checked": {
            color: theme.palette.primary,
        },
    },
}));
